// extracted by mini-css-extract-plugin
export default {"masked":"masked-value_masked__h1RMm","text":"masked-value_text__pu2aS","compact":"masked-value_compact__9bpkY","grain":"masked-value_grain__DxFkN"};